var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDataRiskSuggestionTrash = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.25882 2.89807L5.43137 2.25412C5.57431 1.72066 6.12265 1.40408 6.65611 1.54702L9.79537 2.38818L11.1596 1.65473C11.3839 1.53411 11.6459 1.50365 11.8919 1.56958L16.5994 2.83094C16.8454 2.89687 17.057 3.05421 17.191 3.27086L18.0057 4.58814L21.145 5.4293C21.6785 5.57225 21.995 6.12058 21.8521 6.65405L21.6796 7.298C21.5366 7.83146 20.9883 8.14805 20.4548 8.00511L5.96593 4.12282C5.43246 3.97988 5.11588 3.43154 5.25882 2.89807ZM20 9.00127H5L6.30854 21.2143C6.41743 22.2306 7.27507 23.0013 8.29716 23.0013H16.7028C17.7249 23.0013 18.5826 22.2306 18.6915 21.2143L20 9.00127Z",
    fill: "#071A24",
    fillOpacity: 0.25
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDataRiskSuggestionTrash);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/data_risk_suggestion_trash.402f57dc67992f9af2c915201ebd6ad9.svg";